export default function (data) {
  if (!data) {
    return null
  }

  return {
    email: data.email,
    phone: data.phone,
    region: data.region,
    sumRegion: data.sum_region,
    emailApproved: data.email_approved,
    phoneApproved: data.phone_approved,
    username: data.username,
    vip: data.vip,
    currency: {
      name: data.currency_name,
      code: data.currency_code,
    },
    thresholdStatus: data.threshold_status,
    threshold: {
      amount: data.threshold_sum,
      current: data.current_threshold_sum,
    },
    activeVager: data.active_vager,
    receiveSms: data.receive_sms,
    minPay: data.min_pay,
    minPaySum: data.get_min_paysumm,
    specialUser: data.special_user,
    dobpay: data.dobpay,
    language: data.language,
    withdrawAccess: data.withdraw_access,
    withdrawAccessStr: data.withdraw_access_str,
    profileIsApproved: data.profile_is_approved,
    profileIsApprovedSum: data.profile_is_approved_sum,
    bkProfileIsApproved: data.bk_profile_is_approved,
    personalDataIsFilled: data.personal_data_is_filled,
    securityQuestionId: data.security_question_id,
    securityQuestionAnswer: data.security_question_answer,
    documentNum: data.document_num,
    name: data.name,
    middleName: data.middle_name,
    surname: data.surname,
  }
}
